import { type Attrs, type DOMOutputSpec, type Node, type NodeSpec } from "prosemirror-model";

// :: NodeSpec A page link node that represents a wiki-style link to another page
// within the same document. Stored as [[Page Title]] in markdown.
// Titles with special characters are escaped: ] -> \] and / -> \/

export const page_link: NodeSpec = {
	attrs: {
		pageTitle: { default: "" },
		displayText: { default: null },
	},
	group: "inline",
	inline: true,
	atom: true,
	parseDOM: [
		{
			tag: "span[data-page-link]",
			getAttrs(node: string | HTMLElement) {
				if (typeof node === "string") {
					return {};
				}

				const pageTitle = node.getAttribute("data-page-title") || "";
				const displayText = node.getAttribute("data-page-display");

				const attrs: Attrs = {
					pageTitle,
					displayText,
				};

				return attrs;
			},
		},
	],
	toDOM(node: Node) {
		const attrs: Record<string, string> = {
			"data-page-link": "true",
			"data-page-title": node.attrs["pageTitle"],
		};
		if (node.attrs["displayText"]) {
			attrs["data-page-display"] = node.attrs["displayText"];
		}

		const dom: DOMOutputSpec = ["span", attrs];

		return dom;
	},
};
